import 'bootstrap/js/dist/collapse';
import '../styles/page-about-individual.scss'

/*************************
 Function to check if element is visible
 *************************/
    jQuery(function ($) {
        $('#personMeetingScroll').click(function () {
            var target = $('#personMeetingForm');
            $('html,body').stop().animate({
                scrollTop: target.offset().top - 50
            }, 'linear');
        });
    });

if (window.innerWidth < 576) {
    var observerform = new IntersectionObserver(function (entries) {
        // since there is a single target to be observed, there will be only one entry
        let scrollingButton = document.getElementById('personMeetingScroll');
        if (entries[0]['isIntersecting'] === true) {
            if (entries[0]['intersectionRatio'] === 1 || entries[0]['intersectionRatio'] > 0.1) {
                scrollingButton.classList.add('d-none');
            } else {

            }
        } else {
            //console.log('Target is not visible in the screen');
            scrollingButton.classList.remove('d-none');
        }
    }, {threshold: [0, 0.1, 1]});

    observerform.observe(document.querySelector("#personMeetingForm"));
}